export const myAge = calculateAge(new Date(1996, 11, 16))
export const currentYear = new Date().getFullYear()

function calculateAge(dob: Date) {

  const birthday = +new Date(dob);
  return ~~((Date.now() - birthday) / (31557600000));

}
